@if (!isDismissed()) {
  <pr-information-box [theme]="theme()">
    <ng-content />
    <button mat-button type="button" (click)="dismiss()">
      Don't show again
    </button>
  </pr-information-box>
}
